export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fd003057959c073bdf7cc2aa8a74968d5ba3d4431&name=fetchTypeahead!'